import backgroundLoopMp3 from './assets/background_loop.mp3';
import backgroundLoopAac from './assets/background_loop.aac';
import answerMp3 from './assets/answer.mp3';
import answerAac from './assets/answer.aac';
import headlineMp3 from './assets/headline.mp3';
import headlineAac from './assets/headline.aac';
import shockMp3 from './assets/shock.mp3';
import shockAac from './assets/shock.aac';
import swipeMp3 from './assets/swipe.mp3';
import swipeAac from './assets/swipe.aac';
import userMp3 from './assets/userCount.mp3';
import userAac from './assets/userCount.aac';
import voiceOver_01Mp3 from './assets/voiceOver_01.mp3';
import voiceOver_01Aac from './assets/voiceOver_01.aac';
import voiceOver_02Mp3 from './assets/voiceOver_02.mp3';
import voiceOver_02Aac from './assets/voiceOver_02.aac';

export const players = {
  background: {},
  fxA: {},
  fxB: {},
  voice: {},
};

export const sounds = {
  music: {
    source: {
      mp3: backgroundLoopMp3,
      aac: backgroundLoopAac,
    },
    loop: true,
    volume: 1,
  },
  answer: {
    mp3: answerMp3,
    aac: answerAac,
  },
  headline: {
    mp3: headlineMp3,
    aac: headlineAac,
  },
  shock: {
    source: {
      mp3: shockMp3,
      aac: shockAac,
    },
    volume: 0.2,
  },
  swipe: {
    source: {
      mp3: swipeMp3,
      aac: swipeAac,
    },
    volume: 0.8,
  },
  user: {
    mp3: userMp3,
    aac: userAac,
  },
  voiceOver_01: {
    mp3: voiceOver_01Mp3,
    aac: voiceOver_01Aac,
  },
  voiceOver_02: {
    mp3: voiceOver_02Mp3,
    aac: voiceOver_02Aac,
  },
};
